import React from 'react';
import propTypes from 'prop-types';
import { Stack, Center, Box, Flex } from '@chakra-ui/react';
import { LogoWordmark } from '@outdoorly/logo';
import { NotificationBadge } from '@outdoorly/notification-badge';
import { SearchIcon, ShoppingBagIcon, MenuIcon } from '@outdoorly/icons';
import { Divider } from '@outdoorly/divider';
import NextLink from 'next/link';
import { IconButton } from '@outdoorly/button';

/**
 * A simplified header for use on mobile. To be paired with `<MobileMenu />`.
 */
var MobileHeader = function MobileHeader(_ref) {
  var _ref$onMenuToggle = _ref.onMenuToggle,
    onMenuToggle = _ref$onMenuToggle === void 0 ? function () {} : _ref$onMenuToggle,
    _ref$cartItems = _ref.cartItems,
    cartItems = _ref$cartItems === void 0 ? 0 : _ref$cartItems,
    _ref$onSearch = _ref.onSearch,
    onSearch = _ref$onSearch === void 0 ? function () {} : _ref$onSearch;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    as: "header",
    bg: "scheme.bgPrimary",
    spacing: 4,
    pt: 4,
    px: 2
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    align: "center",
    px: 2
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 4
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onSearch,
    variant: "ghost",
    icon: /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(SearchIcon, {
      width: 6,
      height: 6
    }))
  }), /*#__PURE__*/React.createElement(Box, {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    justify: "center"
  }, /*#__PURE__*/React.createElement(NextLink, {
    href: "/",
    passHref: true
  }, /*#__PURE__*/React.createElement(Box, {
    as: "a",
    "aria-label": "Home"
  }, /*#__PURE__*/React.createElement(LogoWordmark, {
    height: ["25px", "30px"]
  })))), /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: 4
  }, /*#__PURE__*/React.createElement(NextLink, {
    href: "/cart",
    "aria-label": "Cart",
    passHref: true
  }, /*#__PURE__*/React.createElement(Center, {
    as: "a"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(NotificationBadge, {
      size: "sm",
      badge: cartItems,
      isBadgeVisible: typeof cartItems === 'number' && cartItems > 0
    }, /*#__PURE__*/React.createElement(ShoppingBagIcon, {
      width: 6,
      height: 6
    }))),
    variant: "ghost"
  }))), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onMenuToggle,
    variant: "ghost",
    icon: /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(MenuIcon, {
      width: 6,
      height: 6
    }))
  }))), /*#__PURE__*/React.createElement(Divider, null)));
};
MobileHeader.propTypes = {
  onMenuToggle: propTypes.func,
  cartItems: propTypes.number,
  onSearch: propTypes.func
};

export { MobileHeader, MobileHeader as default };
